import styled from 'styled-components';
import Nav from '../Nav';

export const DashboardStc = styled.div`
    min-height: 100vh;
    background-color: #f4f6f9;

    #dorik_hw_notification {
        left: 25px;
    display: flex;
    bottom: 25px;
    position: fixed;
    background: #fff;
    align-items: center;
    border-radius: 25px;
    padding: 5px 12px 5px 7px;
    box-shadow: 0 4px 8px 0 rgba(43,53,86,0.05);

    .text {
        color: var(--color-text-300);
    }

    .HW_badge_cont {
        width: 40px;
        height: 40px;
        margin-right: 10px
        border-radius: 100%;
        border: 1px solid #e5ebf0;
    }

    .HW_badge {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const MainNav = styled(Nav)`
    height: 70px;
    font-size: 18px;
`;

export const MenuBar = styled.div`
    margin-left: 15px;
    @media screen and (min-width: 1024px) {
        display: none;
    }
`;

export const NavIcon = styled.button`
    background: none;
    cursor: pointer;
    border: none;
    outline: none;
`;

export const Line = styled.span`
    display: block;
    border-radius: 50px;
    width: 25px;
    height: 3px;
    margin: 5px;
    background-color: gray;
    transition: width 0.4s ease-in-out;

    :nth-child(2) {
        width: ${(props) => (props.open ? '40%' : '70%')};
    }
`;

export const NavLead = styled.span`
    width: 100px;
    display: inline-block;
`;
